<template>

  <Transition name="fade">
    <NoticeModal v-if="isNoticeOpen && noticeInfo.length > 0" :isNoticeOpen="isNoticeOpen" :noticeInfo="noticeInfo"></NoticeModal>
  </Transition>

  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-lg-12">
        <div class="row">
          <div class="col-lg-3 col-md-6 col-12">
            <div class="mb-4 card" @click="this.$router.push('/customer-info-dental')">
              <div class="p-3 card-body onmaum-shadow-dental">
                <div class="d-flex">
                  <div>
                    <div class="text-center icon icon-shape me-3">
                      <i class="fas fa-tooth onmaum-text-dental text-lg opacity-10"></i>
                    </div>
                  </div>
                  <div>
                    <div class="numbers">
                      <p class="mb-0 text-sm text-uppercase font-weight-bold">치과 고객 수(전체/이번달)</p>
                      <h5 class="font-weight-bolder">{{ dentalTotal }}</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-12">
            <div class="mb-4 card" @click="this.$router.push('/customer-info-finger')">
              <div class="p-3 card-body onmaum-shadow-finger">
                <div class="d-flex">
                  <div>
                    <div class="text-center icon icon-shape me-3">
                      <i class="fas fa-fingerprint text-dark text-lg opacity-10"></i>
                    </div>
                  </div>
                  <div>
                    <div class="numbers">
                      <p class="mb-0 text-sm text-uppercase font-weight-bold">지문 고객 수(전체/이번달)</p>
                      <h5 class="font-weight-bolder">{{ fingerTotal }}</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="col-lg-3 col-md-6 col-12">
            <div class="mb-4 card" @click="this.$router.push('/customer-info-pet')">
              <div class="p-3 card-body onmaum-shadow-pet">
                <div class="d-flex">
                  <div>
                    <div class="text-center icon icon-shape me-3">
                      <i class="fas fa-dog onmaum-text-pet text-lg opacity-10"></i>
                    </div>
                  </div>
                  <div>
                    <div class="numbers">
                      <p class="mb-0 text-sm text-uppercase font-weight-bold">혼디도랑 고객 수(전체/이번달)</p>
                      <h5 class="font-weight-bolder">{{ petTotal }}</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
          <div class="col-lg-3 col-md-6 col-12">
            <div class="mb-4 card" @click="this.$router.push('/customer-info-hospital')">
              <div class="p-3 card-body onmaum-shadow-pet">
                <div class="d-flex">
                  <div>
                    <div class="text-center icon icon-shape me-3">
                      <i class="fas fa-hospital-alt text-dark text-lg opacity-10"></i>
                    </div>
                  </div>
                  <div>
                    <div class="numbers">
                      <p class="mb-0 text-sm text-uppercase font-weight-bold">동물병원 고객 수(전체/이번달)</p>
                      <h5 class="font-weight-bolder">{{ hospitalTotal }}</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-12">
            <div class="mb-4 card" @click="this.$router.push('/customer-info-sns')">
              <div class="p-3 card-body onmaum-shadow-sns">
                <div class="d-flex">
                  <div>
                    <div class="text-center icon icon-shape me-3">
                      <i class="fas fa-tablet-alt onmaum-text-sns text-lg opacity-10"></i>
                    </div>
                  </div>
                  <div>
                    <div class="numbers">
                      <p class="mb-0 text-sm text-uppercase font-weight-bold">사이트&SNS 고객 수(전체/이번달)</p>
                      <h5 class="font-weight-bolder">{{ snsTotal }}</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="col-lg-3 col-md-6 col-12">
            <div class="mb-4 card">
              <div class="p-3 card-body">
                <div class="d-flex">
                  <div>
                    <div class="text-center icon icon-shape me-3">
                      <i class="ni ni-badge text-success text-lg opacity-10"></i>
                    </div>
                  </div>
                  <div>
                    <div class="numbers">
                      <p class="mb-0 text-sm text-uppercase font-weight-bold">전체 플래너 수</p>
                      <h5 class="font-weight-bolder">{{ this.$store.state.planner.plannerInfo.length }}</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-12">
            <div class="mb-4 card" @click="this.$router.push('/itsm')">
              <div class="p-3 card-body onmaum-shadow-itsm">
                <div class="d-flex">
                  <div>
                    <div class="text-center icon icon-shape me-3">
                      <i class="ni ni-settings onmaum-text-itsm text-lg opacity-10"></i>
                    </div>
                  </div>
                  <div>
                    <div class="numbers">
                      <p class="mb-0 text-sm text-uppercase font-weight-bold">개선 완료/요청 수</p>
                      <h5 class="font-weight-bolder">{{ completeTotal }}</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>


    <!-- 탭 -->
    <nav>
      <div class="nav nav-tabs" id="nav-tab" role="tablist">
        <button class="nav-link active" id="tab-all" data-bs-toggle="tab" data-bs-target="#content-all" type="button" role="tab" aria-controls="content-all" aria-selected="true">
          <h6><i class="fas fa-heart text-onmaum onmaum-font-1rem"></i> 전체</h6>
        </button>
        <button class="nav-link" id="tab-dental" data-bs-toggle="tab" data-bs-target="#content-dental" type="button" role="tab" aria-controls="content-dental" aria-selected="false">
          <h6><i class="fas fa-tooth onmaum-text-dental onmaum-font-1rem"></i> 치과</h6>
        </button>
        <button class="nav-link" id="tab-finger" data-bs-toggle="tab" data-bs-target="#content-finger" type="button" role="tab" aria-controls="content-finger" aria-selected="false">
          <h6><i class="fas fa-fingerprint text-dark onmaum-font-1rem"></i> 지문</h6>
        </button>
        <button class="nav-link" id="tab-pet" data-bs-toggle="tab" data-bs-target="#content-pet" type="button" role="tab" aria-controls="content-pet" aria-selected="false">
          <h6><i class="fas fa-dog onmaum-text-pet onmaum-font-1rem"></i> 혼디도랑</h6>
        </button>
        <button class="nav-link" id="tab-sns" data-bs-toggle="tab" data-bs-target="#content-sns" type="button" role="tab" aria-controls="content-sns" aria-selected="false">
          <h6><i class="fas fa-tablet-alt onmaum-text-sns onmaum-font-1rem"></i> 사이트 & SNS</h6>
        </button>
      </div>
    </nav>

    <!-- 탭 컨텐츠 -->
    <div class="tab-content bg-white p-2" id="nav-tabContent" style="border: solid 1px; border-color: #fff #dee2e6 #dee2e6 #dee2e6;">

      <!-- 전체 -->
      <div class="tab-pane fade show active" id="content-all" role="tabpanel" aria-labelledby="tab-all" tabindex="0">
        <div class="row">
          <div class="col-lg-6 col-md-6 col-12">
            <div class="card onmaum-h-60-v onmaum-overflow-y-invisible">
              <div class="card-header pb-0">
                <div class="row">
                  <div class="col-6">
                    <h6><i class="fas fa-file-signature text-onmaum onmaum-font-1rem"></i> 플래너별 등록/체결 현황</h6>
                  </div>

                  <div class="col-4 onmaum-dflex">
                    <p class="onmaum-v-center onmaum-h-center onmaum-font-0_8rem m-auto">{{ this.$store.state.customer.dateParam03 }}</p>
                  </div>

                  <div class="col-1 no-drag text-onmaum-hover" @click="this.$store.commit('decDateParam02')"><i class="fas fa-arrow-left"></i></div>
                  <div class="col-1 no-drag text-onmaum-hover" @click="this.$store.commit('incDateParam02');"><i class="fas fa-arrow-right"></i></div>

                </div>
              </div>
              <div class="card-body px-0 pt-0 pb-2">
                <div class="table-responsive p-0">
                  <table class="table align-items-center mb-0">
                    <thead>
                      <tr>
                        <th class="text-center text-secondary text-xxs font-weight-bolder opacity-7">플래너</th>
                        <th class="text-center text-secondary text-xxs font-weight-bolder opacity-7">등록고객수</th>
                        <th class="text-center text-secondary text-xxs font-weight-bolder opacity-7">체결건수</th>
                        <th class="text-center text-secondary text-xxs font-weight-bolder opacity-7">체결률</th>
                        <th class="text-center text-secondary text-xxs font-weight-bolder opacity-7">보험료계</th>
                        <th class="text-center text-secondary text-xxs font-weight-bolder opacity-7">건당 보험료 평균</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="aPlannerStatistics.length == 0">
                        <td colspan="6" class="text-center">상담/체결 정보가 없습니다.</td>
                      </tr>
                      <tr v-for="(ps, i) in aPlannerStatistics" :key="i" class="onmaum-text-black" :class="i == 0 ? `bg-onmaum-gold`: i == 1 ? `bg-onmaum-silver` : i == 2 ? `bg-onmaum-bronze` : ''">
                        <td class="text-center" :class="i == 0 ? `onmaum-dflex-row onmaum-h-center`:``">
                          <i v-if="i == 0" class="fas fa-medal onmaum-font-1_2rem" :class="i == 0 ? `onmaum-dflex-row`: ``" style="color: gold;"></i>
                          <h6 class="mb-0 text-sm">{{ ps.name == ''?'기타':ps.name }}</h6>
                        </td>
                        <td class="text-center">
                          <p class="text-xs font-weight-bold mb-0">{{ ps.customer_cnt }}명</p>
                        </td>
                        <td class="text-center">
                          <p class="text-xs font-weight-bold mb-0">{{ ps.contract_cnt }}건</p>
                        </td>
                        <td class="text-center">
                          <p class="text-xs font-weight-bold mb-0">{{ ps.contract_ratio }}%</p>
                        </td>
                        <td class="text-center">
                          <p class="text-xs font-weight-bold mb-0">{{ ps.price_total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}원</p>
                        </td>
                        <td class="text-center">
                          <p class="text-xs font-weight-bold mb-0">{{ ps.price_avg.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}원</p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-md-6 col-12">
            <div class="card onmaum-h-60-v onmaum-overflow-y-invisible">
              <div class="card-header pb-0">
                <div class="row">

                  <div class="col-6">
                    <h6><i class="fas fa-calendar-day text-primary onmaum-font-1rem"></i> 일별 고객 등록/체결 현황</h6>
                  </div>

                  <div class="col-4 onmaum-dflex">
                    <p class="onmaum-v-center onmaum-h-center onmaum-font-0_8rem m-auto">{{ startDt + '~' + endDt }}</p>
                  </div>

                  <div class="col-1 no-drag text-onmaum-hover" @click="this.$store.commit('decDateParam01')"><i class="fas fa-arrow-left"></i></div>
                  <div class="col-1 no-drag text-onmaum-hover" @click="this.$store.commit('incDateParam01');"><i class="fas fa-arrow-right"></i></div>
                  
                </div>
              </div>

              <div class="card-body text-center px-0 pt-0 pb-2">
                <div class="onmaum-dflex p-2">
                  <div class="onmaum-col-1-5th p-2" v-for="(data1, i) in aDateStatistics" :key="i">
                    <div class="text-xs font-weight-bolder">{{ data1.date }}</div>
                    <hr/>
                    <div class="onmaum-dflex-column onmaum-overflow-y-invisible onmaum-h-40-v">
                      <div v-if="data1.data.length == 0"><i class="fas fa-running onmaum-text-contract"></i></div>
                      <div class="onmaum-dflex-row onmaum-badge text-center onmaum-col-100 mb-1" :class="data2.contractFlag?'onmaum-badge-contract':'onmaum-badge-regist'" v-for="(data2, j) in data1.data" :key="j">
                          <div class="onmaum-col-50 onmaum-font-0_8rem onmaum-font-ls--0_1rem">{{ data2.planner }}</div>
                          <div class="onmaum-col-50 onmaum-font-0_7rem onmaum-font-ls--0_1rem">({{ data2.name }})</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <!-- 치과 -->
      <div class="tab-pane fade" id="content-dental" role="tabpanel" aria-labelledby="tab-dental" tabindex="0">
        <div class="row">
          <div class="col-lg-6 col-md-6 col-12">
            <div class="card onmaum-h-60-v onmaum-overflow-y-invisible">
              <div class="card-header pb-0">
                <div class="row">
                  <div class="col-6">
                    <h6><i class="fas fa-file-signature text-onmaum onmaum-font-1rem"></i> 플래너별 등록/체결 현황</h6>
                  </div>

                  <div class="col-4 onmaum-dflex">
                    <p class="onmaum-v-center onmaum-h-center onmaum-font-0_8rem m-auto">{{ this.$store.state.customer.dateParam03 }}</p>
                  </div>

                  <div class="col-1 no-drag text-onmaum-hover" @click="this.$store.commit('decDateParam02')"><i class="fas fa-arrow-left"></i></div>
                  <div class="col-1 no-drag text-onmaum-hover" @click="this.$store.commit('incDateParam02');"><i class="fas fa-arrow-right"></i></div>

                </div>
              </div>
              <div class="card-body px-0 pt-0 pb-2">
                <div class="table-responsive p-0">
                  <table class="table align-items-center mb-0">
                    <thead>
                      <tr>
                        <th class="text-center text-secondary text-xxs font-weight-bolder opacity-7">플래너</th>
                        <th class="text-center text-secondary text-xxs font-weight-bolder opacity-7">등록고객수</th>
                        <th class="text-center text-secondary text-xxs font-weight-bolder opacity-7">체결건수</th>
                        <th class="text-center text-secondary text-xxs font-weight-bolder opacity-7">체결률</th>
                        <th class="text-center text-secondary text-xxs font-weight-bolder opacity-7">보험료계</th>
                        <th class="text-center text-secondary text-xxs font-weight-bolder opacity-7">건당 보험료 평균</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="dPlannerStatistics.length == 0">
                        <td colspan="6" class="text-center">상담/체결 정보가 없습니다.</td>
                      </tr>
                      <tr v-for="(ps, i) in dPlannerStatistics" :key="i" class="onmaum-text-black" :class="i == 0 ? `bg-onmaum-gold`: i == 1 ? `bg-onmaum-silver` : i == 2 ? `bg-onmaum-bronze` : ''">
                        <td class="text-center" :class="i == 0 ? `onmaum-dflex-row onmaum-h-center`:``">
                          <i v-if="i == 0" class="fas fa-medal onmaum-font-1_2rem" :class="i == 0 ? `onmaum-dflex-row`: ``" style="color: gold;"></i>
                          <h6 class="mb-0 text-sm">{{ ps.name == ''?'기타':ps.name }}</h6>
                        </td>
                        <td class="text-center">
                          <p class="text-xs font-weight-bold mb-0">{{ ps.customer_cnt }}명</p>
                        </td>
                        <td class="text-center">
                          <p class="text-xs font-weight-bold mb-0">{{ ps.contract_cnt }}건</p>
                        </td>
                        <td class="text-center">
                          <p class="text-xs font-weight-bold mb-0">{{ ps.contract_ratio }}%</p>
                        </td>
                        <td class="text-center">
                          <p class="text-xs font-weight-bold mb-0">{{ ps.price_total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}원</p>
                        </td>
                        <td class="text-center">
                          <p class="text-xs font-weight-bold mb-0">{{ ps.price_avg.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}원</p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-md-6 col-12">
            <div class="card onmaum-h-60-v onmaum-overflow-y-invisible">
              <div class="card-header pb-0">
                <div class="row">

                  <div class="col-6">
                    <h6><i class="fas fa-calendar-day text-primary onmaum-font-1rem"></i> 일별 고객 등록/체결 현황</h6>
                  </div>

                  <div class="col-4 onmaum-dflex">
                    <p class="onmaum-v-center onmaum-h-center onmaum-font-0_8rem m-auto">{{ startDt + '~' + endDt }}</p>
                  </div>

                  <div class="col-1 no-drag text-onmaum-hover" @click="this.$store.commit('decDateParam01')"><i class="fas fa-arrow-left"></i></div>
                  <div class="col-1 no-drag text-onmaum-hover" @click="this.$store.commit('incDateParam01');"><i class="fas fa-arrow-right"></i></div>
                  
                </div>
              </div>

              <div class="card-body text-center px-0 pt-0 pb-2">
                <div class="onmaum-dflex p-2">
                  <div class="onmaum-col-1-5th p-2" v-for="(data1, i) in dDateStatistics" :key="i">
                    <div class="text-xs font-weight-bolder">{{ data1.date }}</div>
                    <hr/>
                    <div class="onmaum-dflex-column onmaum-overflow-y-invisible onmaum-h-40-v">
                      <div v-if="data1.data.length == 0"><i class="fas fa-running onmaum-text-contract"></i></div>
                      <div class="onmaum-dflex-row onmaum-badge text-center onmaum-col-100 mb-1" :class="data2.contractFlag?'onmaum-badge-contract':'onmaum-badge-regist'" v-for="(data2, j) in data1.data" :key="j">
                          <div class="onmaum-col-50 onmaum-font-0_8rem">{{ data2.planner }}</div>
                          <div class="onmaum-col-50 onmaum-font-0_7rem">({{ data2.name }})</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <!-- 지문 -->
      <div class="tab-pane fade" id="content-finger" role="tabpanel" aria-labelledby="tab-finger" tabindex="0">
        <div class="row">
          <div class="col-lg-6 col-md-6 col-12">
            <div class="card onmaum-h-60-v onmaum-overflow-y-invisible">
              <div class="card-header pb-0">
                <div class="row">
                  <div class="col-6">
                    <h6><i class="fas fa-file-signature text-onmaum onmaum-font-1rem"></i> 플래너별 등록/체결 현황</h6>
                  </div>

                  <div class="col-4 onmaum-dflex">
                    <p class="onmaum-v-center onmaum-h-center onmaum-font-0_8rem m-auto">{{ this.$store.state.customer.dateParam03 }}</p>
                  </div>

                  <div class="col-1 no-drag text-onmaum-hover" @click="this.$store.commit('decDateParam02')"><i class="fas fa-arrow-left"></i></div>
                  <div class="col-1 no-drag text-onmaum-hover" @click="this.$store.commit('incDateParam02');"><i class="fas fa-arrow-right"></i></div>

                </div>
              </div>
              <div class="card-body px-0 pt-0 pb-2">
                <div class="table-responsive p-0">
                  <table class="table align-items-center mb-0">
                    <thead>
                      <tr>
                        <th class="text-center text-secondary text-xxs font-weight-bolder opacity-7">플래너</th>
                        <th class="text-center text-secondary text-xxs font-weight-bolder opacity-7">등록고객수</th>
                        <th class="text-center text-secondary text-xxs font-weight-bolder opacity-7">체결건수</th>
                        <th class="text-center text-secondary text-xxs font-weight-bolder opacity-7">체결률</th>
                        <th class="text-center text-secondary text-xxs font-weight-bolder opacity-7">보험료계</th>
                        <th class="text-center text-secondary text-xxs font-weight-bolder opacity-7">건당 보험료 평균</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="fPlannerStatistics.length == 0">
                        <td colspan="6" class="text-center">상담/체결 정보가 없습니다.</td>
                      </tr>
                      <tr v-for="(ps, i) in fPlannerStatistics" :key="i" class="onmaum-text-black" :class="i == 0 ? `bg-onmaum-gold`: i == 1 ? `bg-onmaum-silver` : i == 2 ? `bg-onmaum-bronze` : ''">
                        <td class="text-center" :class="i == 0 ? `onmaum-dflex-row onmaum-h-center`:``">
                          <i v-if="i == 0" class="fas fa-medal onmaum-font-1_2rem" :class="i == 0 ? `onmaum-dflex-row`: ``" style="color: gold;"></i>
                          <h6 class="mb-0 text-sm">{{ ps.name == ''?'기타':ps.name }}</h6>
                        </td>
                        <td class="text-center">
                          <p class="text-xs font-weight-bold mb-0">{{ ps.customer_cnt }}명</p>
                        </td>
                        <td class="text-center">
                          <p class="text-xs font-weight-bold mb-0">{{ ps.contract_cnt }}건</p>
                        </td>
                        <td class="text-center">
                          <p class="text-xs font-weight-bold mb-0">{{ ps.contract_ratio }}%</p>
                        </td>
                        <td class="text-center">
                          <p class="text-xs font-weight-bold mb-0">{{ ps.price_total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}원</p>
                        </td>
                        <td class="text-center">
                          <p class="text-xs font-weight-bold mb-0">{{ ps.price_avg.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}원</p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-md-6 col-12">
            <div class="card onmaum-h-60-v onmaum-overflow-y-invisible">
              <div class="card-header pb-0">
                <div class="row">

                  <div class="col-6">
                    <h6><i class="fas fa-calendar-day text-primary onmaum-font-1rem"></i> 일별 고객 등록/체결 현황</h6>
                  </div>

                  <div class="col-4 onmaum-dflex">
                    <p class="onmaum-v-center onmaum-h-center onmaum-font-0_8rem m-auto">{{ startDt + '~' + endDt }}</p>
                  </div>

                  <div class="col-1 no-drag text-onmaum-hover" @click="this.$store.commit('decDateParam01')"><i class="fas fa-arrow-left"></i></div>
                  <div class="col-1 no-drag text-onmaum-hover" @click="this.$store.commit('incDateParam01');"><i class="fas fa-arrow-right"></i></div>
                  
                </div>
              </div>

              <div class="card-body text-center px-0 pt-0 pb-2">
                <div class="onmaum-dflex p-2">
                  <div class="onmaum-col-1-5th p-2" v-for="(data1, i) in fDateStatistics" :key="i">
                    <div class="text-xs font-weight-bolder">{{ data1.date }}</div>
                    <hr/>
                    <div class="onmaum-dflex-column onmaum-overflow-y-invisible onmaum-h-40-v">
                      <div v-if="data1.data.length == 0"><i class="fas fa-running onmaum-text-contract"></i></div>
                      <div class="onmaum-dflex-row onmaum-badge text-center onmaum-col-100 mb-1" :class="data2.contractFlag?'onmaum-badge-contract':'onmaum-badge-regist'" v-for="(data2, j) in data1.data" :key="j">
                          <div class="onmaum-col-50 onmaum-font-0_8rem">{{ data2.planner }}</div>
                          <div class="onmaum-col-50 onmaum-font-0_7rem">({{ data2.name }})</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <!-- 혼디도랑 -->
      <div class="tab-pane fade" id="content-pet" role="tabpanel" aria-labelledby="tab-pet" tabindex="0">
        <div class="row">
          <div class="col-lg-6 col-md-6 col-12">
            <div class="card onmaum-h-60-v onmaum-overflow-y-invisible">
              <div class="card-header pb-0">
                <div class="row">
                  <div class="col-6">
                    <h6><i class="fas fa-file-signature text-onmaum onmaum-font-1rem"></i> 플래너별 등록/체결 현황</h6>
                  </div>

                  <div class="col-4 onmaum-dflex">
                    <p class="onmaum-v-center onmaum-h-center onmaum-font-0_8rem m-auto">{{ this.$store.state.customer.dateParam03 }}</p>
                  </div>

                  <div class="col-1 no-drag text-onmaum-hover" @click="this.$store.commit('decDateParam02')"><i class="fas fa-arrow-left"></i></div>
                  <div class="col-1 no-drag text-onmaum-hover" @click="this.$store.commit('incDateParam02');"><i class="fas fa-arrow-right"></i></div>

                </div>
              </div>
              <div class="card-body px-0 pt-0 pb-2">
                <div class="table-responsive p-0">
                  <table class="table align-items-center mb-0">
                    <thead>
                      <tr>
                        <th class="text-center text-secondary text-xxs font-weight-bolder opacity-7">플래너</th>
                        <th class="text-center text-secondary text-xxs font-weight-bolder opacity-7">등록고객수</th>
                        <th class="text-center text-secondary text-xxs font-weight-bolder opacity-7">체결건수</th>
                        <th class="text-center text-secondary text-xxs font-weight-bolder opacity-7">체결률</th>
                        <th class="text-center text-secondary text-xxs font-weight-bolder opacity-7">보험료계</th>
                        <th class="text-center text-secondary text-xxs font-weight-bolder opacity-7">건당 보험료 평균</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="pPlannerStatistics.length == 0">
                        <td colspan="6" class="text-center">상담/체결 정보가 없습니다.</td>
                      </tr>
                      <tr v-for="(ps, i) in pPlannerStatistics" :key="i" class="onmaum-text-black" :class="i == 0 ? `bg-onmaum-gold`: i == 1 ? `bg-onmaum-silver` : i == 2 ? `bg-onmaum-bronze` : ''">
                        <td class="text-center" :class="i == 0 ? `onmaum-dflex-row onmaum-h-center`:``">
                          <i v-if="i == 0" class="fas fa-medal onmaum-font-1_2rem" :class="i == 0 ? `onmaum-dflex-row`: ``" style="color: gold;"></i>
                          <h6 class="mb-0 text-sm">{{ ps.name == ''?'기타':ps.name }}</h6>
                        </td>
                        <td class="text-center">
                          <p class="text-xs font-weight-bold mb-0">{{ ps.customer_cnt }}명</p>
                        </td>
                        <td class="text-center">
                          <p class="text-xs font-weight-bold mb-0">{{ ps.contract_cnt }}건</p>
                        </td>
                        <td class="text-center">
                          <p class="text-xs font-weight-bold mb-0">{{ ps.contract_ratio }}%</p>
                        </td>
                        <td class="text-center">
                          <p class="text-xs font-weight-bold mb-0">{{ ps.price_total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}원</p>
                        </td>
                        <td class="text-center">
                          <p class="text-xs font-weight-bold mb-0">{{ ps.price_avg.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}원</p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-md-6 col-12">
            <div class="card onmaum-h-60-v onmaum-overflow-y-invisible">
              <div class="card-header pb-0">
                <div class="row">

                  <div class="col-6">
                    <h6><i class="fas fa-calendar-day text-primary onmaum-font-1rem"></i> 일별 고객 등록/체결 현황</h6>
                  </div>

                  <div class="col-4 onmaum-dflex">
                    <p class="onmaum-v-center onmaum-h-center onmaum-font-0_8rem m-auto">{{ startDt + '~' + endDt }}</p>
                  </div>

                  <div class="col-1 no-drag text-onmaum-hover" @click="this.$store.commit('decDateParam01')"><i class="fas fa-arrow-left"></i></div>
                  <div class="col-1 no-drag text-onmaum-hover" @click="this.$store.commit('incDateParam01');"><i class="fas fa-arrow-right"></i></div>
                  
                </div>
              </div>

              <div class="card-body text-center px-0 pt-0 pb-2">
                <div class="onmaum-dflex p-2">
                  <div class="onmaum-col-1-5th p-2" v-for="(data1, i) in pDateStatistics" :key="i">
                    <div class="text-xs font-weight-bolder">{{ data1.date }}</div>
                    <hr/>
                    <div class="onmaum-dflex-column onmaum-overflow-y-invisible onmaum-h-40-v">
                      <div v-if="data1.data.length == 0"><i class="fas fa-running onmaum-text-contract"></i></div>
                      <div class="onmaum-dflex-row onmaum-badge text-center onmaum-col-100 mb-1" :class="data2.contractFlag?'onmaum-badge-contract':'onmaum-badge-regist'" v-for="(data2, j) in data1.data" :key="j">
                          <div class="onmaum-col-50 onmaum-font-0_8rem">{{ data2.planner }}</div>
                          <div class="onmaum-col-50 onmaum-font-0_7rem">({{ data2.name }})</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <!-- SNS -->
      <div class="tab-pane fade" id="content-sns" role="tabpanel" aria-labelledby="tab-sns" tabindex="0">
        <div class="row">
          <div class="col-lg-6 col-md-6 col-12">
            <div class="card onmaum-h-60-v onmaum-overflow-y-invisible">
              <div class="card-header pb-0">
                <div class="row">
                  <div class="col-6">
                    <h6><i class="fas fa-file-signature text-onmaum onmaum-font-1rem"></i> 플래너별 등록/체결 현황</h6>
                  </div>

                  <div class="col-4 onmaum-dflex">
                    <p class="onmaum-v-center onmaum-h-center onmaum-font-0_8rem m-auto">{{ this.$store.state.customer.dateParam03 }}</p>
                  </div>

                  <div class="col-1 no-drag text-onmaum-hover" @click="this.$store.commit('decDateParam02')"><i class="fas fa-arrow-left"></i></div>
                  <div class="col-1 no-drag text-onmaum-hover" @click="this.$store.commit('incDateParam02');"><i class="fas fa-arrow-right"></i></div>

                </div>
              </div>
              <div class="card-body px-0 pt-0 pb-2">
                <div class="table-responsive p-0">
                  <table class="table align-items-center mb-0">
                    <thead>
                      <tr>
                        <th class="text-center text-secondary text-xxs font-weight-bolder opacity-7">플래너</th>
                        <th class="text-center text-secondary text-xxs font-weight-bolder opacity-7">등록고객수</th>
                        <th class="text-center text-secondary text-xxs font-weight-bolder opacity-7">체결건수</th>
                        <th class="text-center text-secondary text-xxs font-weight-bolder opacity-7">체결률</th>
                        <th class="text-center text-secondary text-xxs font-weight-bolder opacity-7">보험료계</th>
                        <th class="text-center text-secondary text-xxs font-weight-bolder opacity-7">건당 보험료 평균</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="sPlannerStatistics.length == 0">
                        <td colspan="6" class="text-center">상담/체결 정보가 없습니다.</td>
                      </tr>
                      <tr v-for="(ps, i) in sPlannerStatistics" :key="i" class="onmaum-text-black" :class="i == 0 ? `bg-onmaum-gold`: i == 1 ? `bg-onmaum-silver` : i == 2 ? `bg-onmaum-bronze` : ''">
                        <td class="text-center" :class="i == 0 ? `onmaum-dflex-row onmaum-h-center`:``">
                          <i v-if="i == 0" class="fas fa-medal onmaum-font-1_2rem" :class="i == 0 ? `onmaum-dflex-row`: ``" style="color: gold;"></i>
                          <h6 class="mb-0 text-sm">{{ ps.name == ''?'기타':ps.name }}</h6>
                        </td>
                        <td class="text-center">
                          <p class="text-xs font-weight-bold mb-0">{{ ps.customer_cnt }}명</p>
                        </td>
                        <td class="text-center">
                          <p class="text-xs font-weight-bold mb-0">{{ ps.contract_cnt }}건</p>
                        </td>
                        <td class="text-center">
                          <p class="text-xs font-weight-bold mb-0">{{ ps.contract_ratio }}%</p>
                        </td>
                        <td class="text-center">
                          <p class="text-xs font-weight-bold mb-0">{{ ps.price_total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}원</p>
                        </td>
                        <td class="text-center">
                          <p class="text-xs font-weight-bold mb-0">{{ ps.price_avg.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}원</p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-md-6 col-12">
            <div class="card onmaum-h-60-v onmaum-overflow-y-invisible">
              <div class="card-header pb-0">
                <div class="row">

                  <div class="col-6">
                    <h6><i class="fas fa-calendar-day text-primary onmaum-font-1rem"></i> 일별 고객 등록/체결 현황</h6>
                  </div>

                  <div class="col-4 onmaum-dflex">
                    <p class="onmaum-v-center onmaum-h-center onmaum-font-0_8rem m-auto">{{ startDt + '~' + endDt }}</p>
                  </div>

                  <div class="col-1 no-drag text-onmaum-hover" @click="this.$store.commit('decDateParam01')"><i class="fas fa-arrow-left"></i></div>
                  <div class="col-1 no-drag text-onmaum-hover" @click="this.$store.commit('incDateParam01');"><i class="fas fa-arrow-right"></i></div>
                  
                </div>
              </div>

              <div class="card-body text-center px-0 pt-0 pb-2">
                <div class="onmaum-dflex p-2">
                  <div class="onmaum-col-1-5th p-2" v-for="(data1, i) in sDateStatistics" :key="i">
                    <div class="text-xs font-weight-bolder">{{ data1.date }}</div>
                    <hr/>
                    <div class="onmaum-dflex-column onmaum-overflow-y-invisible onmaum-h-40-v">
                      <div v-if="data1.data.length == 0"><i class="fas fa-running onmaum-text-contract"></i></div>
                      <div class="onmaum-dflex-row onmaum-badge text-center onmaum-col-100 mb-1" :class="data2.contractFlag?'onmaum-badge-contract':'onmaum-badge-regist'" v-for="(data2, j) in data1.data" :key="j">
                          <div class="onmaum-col-50 onmaum-font-0_8rem">{{ data2.planner }}</div>
                          <div class="onmaum-col-50 onmaum-font-0_7rem">({{ data2.name }})</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import NoticeModal from '@/views/components/NoticeModal.vue'

export default {
  name: "main-page",
  
  data() {
    return {
      isNoticeOpen: this.$store.state.login.isLogin
                      ?this.$cookies.isKey('isNoticeOpen')
                        ?this.$cookies.get('isNoticeOpen')=='false'
                          ?false
                          :true
                        :true
                      :false,
    }
  },
  components: {
    NoticeModal,
  },
  computed:{
    dentalTotal(){
      return this.$store.getters.getDentalTotalCount;
    },
    fingerTotal(){
      return this.$store.getters.getFingerTotalCount;
    },
    petTotal(){
      return this.$store.getters.getPetTotalCount;
    },
    hospitalTotal(){
      return this.$store.getters.getHospitalTotalCount;
    },
    snsTotal(){
      return this.$store.getters.getSnsTotalCount;
    },
    completeTotal(){
      return this.$store.getters.getCompleteTotalRatio;
    },
    aPlannerStatistics(){
      return this.$store.getters.getAllPlannerStatistics;
    },
    dPlannerStatistics(){
      return this.$store.getters.getDentalPlannerStatistics;
    },
    fPlannerStatistics(){
      return this.$store.getters.getFingerPlannerStatistics;
    },
    pPlannerStatistics(){
      return this.$store.getters.getPetPlannerStatistics;
    },
    sPlannerStatistics(){
      return this.$store.getters.getSnsPlannerStatistics;
    },
    aDateStatistics(){
      return this.$store.getters.getAllDateStatistics;
    },
    dDateStatistics(){
      return this.$store.getters.getDentalDateStatistics;
    },
    fDateStatistics(){
      return this.$store.getters.getFingerDateStatistics;
    },
    pDateStatistics(){
      return this.$store.getters.getPetDateStatistics;
    },
    sDateStatistics(){
      return this.$store.getters.getSnsDateStatistics;
    },
    startDt(){
      return this.$store.getters.getStartDt;
    },
    endDt(){
      return this.$store.getters.getEndDt;
    },
    today(){
      let dt = new Date();
      dt.setDate(dt.getDate() + 1);
      dt = dt.toLocaleDateString();
      return new Date(dt).getTime();
    },
    dayAgo(){
      let dt = new Date();
      dt = dt.toLocaleDateString();
      return new Date(dt).getTime();
    },
    weekAgo(){
      let dt = new Date();
      dt.setDate(dt.getDate() - 6);
      dt = dt.toLocaleDateString();
      return new Date(dt).getTime();
    },
    monthAgo(){
      let dt = new Date();
      dt.setDate(dt.getDate() + 1);
      dt.setMonth(dt.getMonth() - 1);
      dt = dt.toLocaleDateString();
      return new Date(dt).getTime();
    },

    //공지사항 정보
    noticeInfo(){
      return this.$store.state.common.noticeInfo;
    },
  },

  mounted(){
    if(!this.$store.state.login.isLogin){
      this.$router.push('/signin');
    }else if(this.$store.state.login.userType == '기타사용자'){
      this.$router.push('/devMain')
    }else{
      //고객 정보 가져오기
      this.$store.dispatch('getCustomerInfo');

      //플래너 정보 가져오기
      this.$store.dispatch('getPlannerInfo');

      //ITSM 정보 가져오기
      this.$store.dispatch('getItsmInfo');

      //공지사항 정보 가져오기
      this.$store.dispatch('getNoticeInfo');

      //푸쉬 알림 권한 요청
      // Notification.requestPermission().then(function(permission) {
      //   if (permission === 'granted') {
      //     console.log('푸시 알림 권한이 허용됨');
      //   } else {
      //     console.log('푸시 알림 권한이 거부됨');
      //   }
      // });
    }
  },

};
</script>

<style>

</style>